import Components from 'slotworks/components/components';
import ButtonElement, { ButtonEvent } from 'slotworks/graphics/elements/button-element';
import Layers from 'slotworks/graphics/layers/layers';
import { CenterPivot, PIXIElement } from 'slotworks/graphics/pixi/group';
import BetMenuMediator from 'slotworks/mediators/bet-menu-mediator';
import betModel from 'slotworks/model/bets/bet-model';
import smartButton, { SmartButtonFlag } from 'slotworks/smart-button/smart-button';
import Contract from 'slotworks/utils/contract';
import deviceInfo from 'slotworks/utils/device-info';
import * as TweenJS from 'slotworks/utils/tween';
import BonusBuyPrompt from './bonus-buy-prompt';
import settingsModel from 'slotworks/model/settings/settings-model';
import { setFullScreenCelebrationFilter } from 'components/ui-helper';
import canvasManager, { Orientation } from 'slotworks/graphics/canvas/canvas-manager';
import doSettingsModel from 'model/do-settings-model';

class BonusBuyComponent {
    private buyButton: ButtonElement;
    private buyPrompt: BonusBuyPrompt;

    private opened: boolean = false;
    private enabled: boolean = false;
    private hidden: boolean = false;

    private active: boolean = false;
    private center: PIXIElement;

    public start() {
        if (Layers.Custom.has('BonusBuy')) {
            Layers.Custom.get('BonusBuy')
                .setScene('bonusbuy')
                .execute();
            this.active = true;
            this.hidden = false;
            this.init();
            if (!deviceInfo.isDesktop) {
                deviceInfo.onLayoutChange.add(() => this.init(), 100);
                Components.betMenu.onSettingsOptionsCommitted.add(() => {
                    setTimeout(this.positionButton, 10);
                });                
            }
        }
    }

    private positionButton = () => {
        if(deviceInfo.layoutPrefix == "landscape-") {
            const positionString = settingsModel.getLeftHanded() ? "right" : "left";
            const position = Layers.Custom.get('BonusBuy').getPosition(positionString);
            if(position) {
                this.center.position.set(position.x + position.width/2, position.y + position.height/2);
            }
        }
    }

    private init = () => {
        this.buyButton = Layers.Custom.get('BonusBuy').getButton('buy');
        if (settingsModel.language == 'zh-Hans') {
            const buyText = Layers.Custom.get('BonusBuy').getText('buy');
            const featureText = Layers.Custom.get('BonusBuy').getText('feature');
            if(buyText && featureText) {
                buyText.y = (buyText.y + featureText.y) / 2;
                featureText.visible = false;
            }
        }
        this.center = CenterPivot(Layers.Custom.get('BonusBuy').container.children as PIXIElement[]);        
        this.buyButton.on(ButtonEvent.POINTER_UP, () => {
            if (!this.opened && this.enabled) {
                this.opened = true;
                this.setEnabled(false);
                smartButton.setFlag(SmartButtonFlag.PROMPT, true);
                if (!deviceInfo.isDesktop) Layers.SmartButton.hide();
                this.initPrompt();
                this.showPrompt().then((success: boolean) => {
                    this.opened = false;
                    this.buyPrompt = null;                    
                    smartButton.setFlag(SmartButtonFlag.PROMPT, false);
                    Layers.SmartButton.show();
                    if (!success) {
                        Components.betBar.setEnabled(true);
                        this.setEnabled(true);               
                    }
                });
            }
        });
        if(this.hidden) {
            this.center.scale.set(0, 0);
        }
        if(!this.enabled) {
            this.buyButton.setEnabled(this.enabled);
            setFullScreenCelebrationFilter();
        }
        if(!deviceInfo.isDesktop) {
            this.positionButton();
        }
    };

    public setEnabled(enabled: boolean) {
        this.enabled = enabled;
        if (this.buyButton) {
            this.buyButton.setEnabled(enabled);
        }
    }

    public show() {
        Layers.Custom.get('BonusBuy').show();
        if (this.active && this.hidden) {
            this.hidden = false;
            this.zoomIn().execute();    
        }
    }

    public hide() {
        if (this.active && !this.hidden) {
            this.hidden = true;
            this.zoomOut().execute();
        }
    }

    public hideWithoutAnimation() {
        if (this.active && !this.hidden) {
            this.hidden = true;
            this.center.scale.set(0,0);
        }
    }

    private zoomIn() {
        return new Contract<void>(resolve => {
            new TweenJS.Tween(this.center.scale)
                .to({ x: 1, y: 1 }, 300)
                .easing(TweenJS.Easing.Back.Out)
                .onComplete(resolve)
                .start();
        });
    }

    private zoomOut() {
        return new Contract<void>(resolve => {
            new TweenJS.Tween(this.center.scale)
                .to({ x: 0, y: 0 }, 300)
                .easing(TweenJS.Easing.Back.In)
                .onComplete(resolve)
                .start();
        });
    }

    private initPrompt() {
        const betOptions = betModel.generateBetOptions();
        Components.betBar.setEnabled(false);
        Components.betBar.setBetOptions(betOptions);
        this.buyPrompt = new BonusBuyPrompt(betOptions);
    }

    private showPrompt(): Contract<boolean> {
        return this.buyPrompt.show();
    }
}

const bonusBuyComponent = new BonusBuyComponent();
export default bonusBuyComponent;



// WEBPACK FOOTER //
// ./src/components/bonus-buy/bonus-buy-component.ts